export { default, DataTableHeader } from './DataTable.js';
